// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__FhpK3","active":"Tab_active__hWoa-","activeIndicator":"Tab_activeIndicator__z+c-Q"};